import PropTypes from 'prop-types';
import React from 'react';

import useFetchPatientMedicationRxNumber from 'App/hooks/useFetchPatientMedicationRxNumber';
import findRelevantRxFill from 'App/utils/findRelevantRxFill';
import { dateOnlySlashesFormat, formatUtcDate } from 'App/services/DateService';

const propTypes = {
    patientId: PropTypes.string.isRequired,
    medication: PropTypes.shape({
        id: PropTypes.string,
    }).isRequired,
};

const defaultProps = {};

function RxFillNumberSideBar({ patientId, medication }) {
    const { data: prescription } = useFetchPatientMedicationRxNumber(patientId, medication.id);

    return (
        <div className="patient-rx-fill">
            {prescription?.map((rx) => {
                const fill = findRelevantRxFill(rx.rxFill);
                const first = rx?.physician?.firstName || '';
                const last = rx?.physician?.lastName || '';
                const prescriberName = `${first} ${last}`.trim();
                return (
                    <div key={rx.id}>
                        {rx?.rxNumber && (
                            <>
                                <span className="rx-fill-label">Rx# </span>
                                <span>{rx.rxNumber}</span> <br />
                            </>
                        )}
                        {rx?.strength && (
                            <>
                                <span className="rx-fill-label">Rx Strength </span>
                                <span>{rx.strength}</span>
                                <br />
                            </>
                        )}
                        {rx?.start && (
                            <>
                                <span className="rx-fill-label">Rx Written </span>
                                <span>{formatUtcDate({ date: rx.start, format: dateOnlySlashesFormat })}</span> <br />
                            </>
                        )}
                        {rx?.fillExpiration && (
                            <>
                                <span className="rx-fill-label">Rx Exp. </span>
                                <span>
                                    {formatUtcDate({
                                        date: rx.fillExpiration,
                                        format: dateOnlySlashesFormat,
                                    })}
                                </span>{' '}
                                <br />
                            </>
                        )}
                        {prescriberName && (
                            <>
                                <span className="rx-fill-label">Prescriber </span>
                                <span>{prescriberName}</span>
                                <br />
                            </>
                        )}
                        {rx?.refillsAuthorized !== undefined && rx?.refillsAuthorized !== null && (
                            <>
                                <span className="rx-fill-label">Refills Allowed </span>
                                <span>{rx.refillsAuthorized}</span>
                                <br />
                            </>
                        )}
                        {fill && (
                            <div className="patient-rx-fill">
                                {(fill?.fillNumber === 0 || fill?.fillNumber) && (
                                    <div>
                                        <span className="rx-fill-label">Fill# </span>
                                        <span>{fill.fillNumber}</span>
                                    </div>
                                )}
                                {fill?.fillDate && (
                                    <div>
                                        <span className="rx-fill-label">Fill Date </span>
                                        <span>
                                            {formatUtcDate({
                                                date: fill.fillDate,
                                                format: dateOnlySlashesFormat,
                                            })}
                                        </span>
                                    </div>
                                )}
                                {(fill?.dispensedQuantity === 0 || fill?.dispensedQuantity) && (
                                    <div>
                                        <span className="rx-fill-label">Dispensed Qty </span>
                                        <span>{fill.dispensedQuantity}</span>
                                    </div>
                                )}
                                {(fill?.daysSupply === 0 || fill?.daysSupply) && (
                                    <div>
                                        <span className="rx-fill-label">Days Supply </span>
                                        <span>{fill.daysSupply}</span>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
}

RxFillNumberSideBar.propTypes = propTypes;
RxFillNumberSideBar.defaultProps = defaultProps;

export default RxFillNumberSideBar;
